import { routes } from 'commons/constants/routes'
import { Document } from 'commons/types/DTO/bank/companyDetails/document'
import { DateTime } from 'ui/components'
import { CheckMark } from 'ui/components/CheckMark'
import { FrequencyLabel } from 'ui/components/Labels'
import { Link } from 'ui/components/Link'
import { TableActions, TableColumn } from 'ui/components/Table'
import { AlertsTooltip } from '~bank-documents/components/AlertsTooltip'

export const columns = (onDeleteDocument: (document: Document | undefined) => void, returnUrl?: string) =>
  [
    {
      title: 'Document Name',
      sortable: true,
      key: 'name',
      align: 'left',
      render: (item) => (
        <Link to="/documents/$documentId" params={{ documentId: item.id.toString() }}>
          {item.name}
        </Link>
      )
    },
    {
      title: 'Internal',
      sortable: true,
      key: 'internal',
      render: ({ internal }) => (internal ? <CheckMark value rounded /> : null)
    },
    {
      title: 'Subject',
      align: 'left',
      render: (item) => (
        <Link
          to={routes.bank.relationships.details}
          params={{
            id: item.company.id
          }}
        >
          {item.company.name}
        </Link>
      )
    },
    {
      title: 'Frequency',
      sortable: true,
      key: 'frequency',
      align: 'left',
      render: ({ frequency }) => <FrequencyLabel name={frequency} />
    },
    {
      title: 'Expiration Date',
      sortable: true,
      key: 'expirationDate',
      align: 'left',
      render: ({ expirationDate }) => <DateTime date={expirationDate} />
    },
    {
      align: 'left',
      title: 'Alerts',
      render: (item) => <AlertsTooltip id={item.id || 0} alerts={item.alerts} />
    },
    {
      title: 'Actions',
      width: '50px',
      render: (item: Document) => (
        <TableActions
          items={[
            {
              type: 'edit',
              url: `/documents/${item?.id}/edit?returnUrl=${returnUrl}`
            },
            {
              type: 'delete',
              onClick: () => onDeleteDocument(item)
            }
          ]}
        />
      )
    }
  ].filter(Boolean) as TableColumn<Document>[]
